export default __webpack_public_path__ + "static/media/Logo.fbcebab3.svg";